module.exports = __webpack_public_path__ + "static/media/user.d0623b53.svg";